<template>
  <div class="info__main">
    <div class="info__header">
      <div class="info__icon">&#57346;</div>
      <div class="info__num">{{ num }}</div>
    </div>
    <div class="info__title" v-if="title">{{ title }}</div>
    <div class="info__content" v-html="content"></div>
  </div>
</template>

<style scoped>
.info__main {
  width: 100%;
  color: #ffffff;
  background-color: #111111;
}

.info__main > div {
  padding: 20px;
}

.info__header {
  display: flex;
}

.info__icon {
  margin-right: 20px;
}

.info__title {
  text-transform: uppercase;
}

@media screen and (max-width: 600px) {
  .info__main {
    width: 100%;
  }
}
</style>

<script>
export default {
  name: "Info",
  props: {
    num: String,
    title: String,
    content: String
  }
};
</script>
